package com.xtream.data_kmp.db.dao


import androidx.paging.PagingSource
import androidx.room3.Dao
import androidx.room3.Query
import com.xtream.data_kmp.FavoriteSeriesStreamEntity
import com.xtream.data_kmp.seriesFavoritesTable
import kotlinx.coroutines.flow.Flow


@Dao
abstract class SeriesFavDao:RoomBaseInterface<FavoriteSeriesStreamEntity> {


    @Query("SELECT * FROM $seriesFavoritesTable")
    abstract override fun allAsFlow(): Flow<List<FavoriteSeriesStreamEntity>>
    @Query("SELECT * FROM $seriesFavoritesTable ")
    abstract override fun allAsPagingSource(): PagingSource<Int, FavoriteSeriesStreamEntity>

    @Query("SELECT EXISTS (SELECT 1 FROM $seriesFavoritesTable WHERE streamId = :id)")

    abstract override suspend fun hasEntity(id:Int):Boolean

    @Query("SELECT EXISTS (SELECT 1 FROM $seriesFavoritesTable WHERE streamId = :id)")

    abstract override fun hasEntityAsFlow(id:Int?):Flow<Boolean>

    @Query("SELECT COUNT(*) FROM $seriesFavoritesTable")
    abstract override suspend fun getSize(): Long?
    @Query("DELETE FROM seriesFavoritesTable")
    abstract override suspend fun deleteAll()
}